import {
  object as yupObject,
  boolean as yupBoolean,
  string as yupString,
  ValidationError as yupValidationError,
} from "yup"

import { phoneRegEx, WEB_TO_LEAD_FORM_IDS } from "./salesForm"

export const RENTAL_READER_LEAD_IDS =
  process.env.GATSBY_CONTACT_FORM_ENVIRONMENT === "STAGING"
    ? {
        oid: process.env.GATSBY_WEB_TO_LEAD_SALESFORCE_OID as string,
        eventName: "00NUB00000BJ6Og",
        existingYocoMerchant: "00NUB00000BJQN4",
        interestedProduct: "00NUB00000BJDdD",
        numberOfDevices: "00NUB00000BJOEr",
        hearAboutSource: "00NUB00000BJCVi",
      }
    : {
        oid: process.env.GATSBY_WEB_TO_LEAD_SALESFORCE_OID as string,
        eventName: "00NSf000006xnin",
        existingYocoMerchant: "00NSf000006xlp4",
        interestedProduct: "00NSf000006xmgI",
        numberOfDevices: "00NSf000006xl98",
        hearAboutSource: "00NSf000006xnne",
      }

export const RENTAL_READER_INITIAL_VALUES = {
  Khumo: false,
  "Neo Touch": false,
  "Khumo Print": false,
  radioErrorMessage: "",
  checkboxErrorMessage: "",
  [WEB_TO_LEAD_FORM_IDS.email]: "",
  [WEB_TO_LEAD_FORM_IDS.phone]: "",
  [WEB_TO_LEAD_FORM_IDS.company]: "",
  [WEB_TO_LEAD_FORM_IDS.last_name]: "",
  [WEB_TO_LEAD_FORM_IDS.first_name]: "",
  [RENTAL_READER_LEAD_IDS.eventName]: "",
  [RENTAL_READER_LEAD_IDS.hearAboutSource]: "",
  [RENTAL_READER_LEAD_IDS.numberOfDevices]: "",
  [RENTAL_READER_LEAD_IDS.interestedProduct]: "",
  [RENTAL_READER_LEAD_IDS.existingYocoMerchant]: "",
}

export const getSelectedInterestedProduct = (
  obj: typeof RENTAL_READER_INITIAL_VALUES
) => {
  const allowedKeys = ["Khumo", "Neo Touch", "Khumo Print"]

  return Object.keys(obj).filter(
    (key) => allowedKeys.includes(key) && obj[key] === true
  )
}

export const RENTAL_READER_VALIDATION_SCHEMA = yupObject({
  [WEB_TO_LEAD_FORM_IDS.first_name]: yupString().required(
    "First name is required"
  ),
  [WEB_TO_LEAD_FORM_IDS.last_name]: yupString().required(
    "Last name is required"
  ),
  [WEB_TO_LEAD_FORM_IDS.phone]: yupString()
    .required("Phone number is required")
    .matches(phoneRegEx, "Valid S.A phone number is required"),
  [WEB_TO_LEAD_FORM_IDS.email]: yupString()
    .email("Email must be a valid email")
    .required("Email address is required"),
  [WEB_TO_LEAD_FORM_IDS.company]: yupString().required(
    "Business name is required"
  ),
  [RENTAL_READER_LEAD_IDS.eventName]: yupString().required(
    "Event name is required"
  ),
  [RENTAL_READER_LEAD_IDS.numberOfDevices]: yupString().required(
    "Number of devices is required"
  ),
  Khumo: yupBoolean(),
  "Neo Touch": yupBoolean(),
  "Khumo Print": yupBoolean(),
  [RENTAL_READER_LEAD_IDS.interestedProduct]: yupString().required(
    "At least one product is required"
  ),
  [RENTAL_READER_LEAD_IDS.existingYocoMerchant]:
    yupString().required("Option is required"),
  [RENTAL_READER_LEAD_IDS.hearAboutSource]:
    yupString().required("Option is required"),
}).test("CheckboxTest", "Check only one checkbox", (obj: any) => {
  // TODO - fix any typing. Yup upgrade might be needed https://github.com/jquense/yup/issues/1906
  const activeCheckboxes = getSelectedInterestedProduct(obj)

  if (activeCheckboxes.length === 1) {
    obj[RENTAL_READER_LEAD_IDS.interestedProduct] = activeCheckboxes[0]
    return true
  }

  return new yupValidationError(
    "Check one checkbox",
    null,
    "checkboxErrorMessage"
  )
})

export const IS_EXISTING_YOCO_MERCHANT_OPTIONS = [
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
]

export const NUMBER_OF_DEVICES_OPTIONS = [
  {
    label: "10",
    value: "10",
  },
  {
    label: "11-20",
    value: "11-20",
  },
  {
    label: "21-30",
    value: "21-30",
  },
]
